import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import axios from "axios";
import { loadStripe } from '@stripe/stripe-js';
import { useRef } from "react";
import { toPng } from "html-to-image";


export default function CustomGradCakeCreator() {
  const [isLoading, setIsLoading] = useState(false);

  const cakeRef = useRef();
  const [numTiers, setNumTiers] = useState("1");
  const [toppers, setToppers] = useState([]);
  const [edibleAddOns, setEdibleAddOns] = useState([]);
  const [customName, setCustomName] = useState("");
  const [dietaryRestrictions, setDietaryRestrictions] = useState([]);
  const [tierFlavors, setTierFlavors] = useState([{ cake: "vanilla", icing: "vanilla buttercream" }]);
  const [formStep, setFormStep] = useState(0);
  const [otherFeedback, setOtherFeedback] = useState("");

  const [reviewMode, setReviewMode] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [contactMethod, setContactMethod] = useState("email");
  const [delivery, setDelivery] = useState(false);
  const [address, setAddress] = useState("");
  const [dateNeeded, setDateNeeded] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState("pickup");

  const contactFieldsAreValid = name && email && phone && dateNeeded;
  const submitDisabled = !agreeTerms || !contactFieldsAreValid ;
  
  const isLocalhost = window.location.hostname === "localhost";

  const showCongratsInput = edibleAddOns.includes("congratulations");

  const stripePromise = loadStripe('pk_live_51Qv8ZdJ0BQBzLdLm3p7wXPUcKQ8HY9c55aR0sYkX0FtCrFPfgrGPmRyASHXk9pCYLfnIrx2HFxBoKlltya6Bj6sW00lX1XVOdc');  // Replace with your Stripe publishable key

  const [discountCode, setDiscountCode] = useState("");

  const [numberofTiersPrice, setNumberofTiersPrice] = useState(85);
  const [toppersPrice, setToppersPrice] = useState(0);
  const [edibleAddonsPrice, setEdibleAddonsPrice] = useState(0);
  const [customMessagePrice, setCustomMessagePrice] = useState(0);
  const [dietaryRestrictionsPrice, setDietaryRestrictionsPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(85); // Initial base price
  const servings = numTiers === "1" ? 20 : 36;
  const [deliveryFee, setDeliveryFee] = useState(0);


  useEffect(() => {
    const base = numTiers === "1" ? 85 : 185;
    setNumberofTiersPrice(base);
  
    const topperTotal = toppers.reduce(
      (sum, t) => sum + (t === "owl" ? 75 : t === "happy graduation" ? 15 : 10),
      0
    );
    setToppersPrice(topperTotal);
  
    const edibleTotal = edibleAddOns.reduce((sum, e) => {
      if (e === "gold foil") return sum + 45;
      if (e === "congratulations") return sum + 20;
      if (e === "ricelogo") return sum + 25;
      return sum;
    }, 0);
    setEdibleAddonsPrice(edibleTotal);

    const calculatedDeliveryFee = deliveryMethod === "delivery" ? 75 : 0;
    setDeliveryFee(calculatedDeliveryFee);

    setCustomMessagePrice(edibleAddOns.includes("congratulations") ? 20 : 0);
  
    const dietaryTotal = dietaryRestrictions.includes("gluten-free") ? servings * 0.3 : 0;
    setDietaryRestrictionsPrice(dietaryTotal);
  
    const total = base + topperTotal + edibleTotal + dietaryTotal + calculatedDeliveryFee;
    const final = ["Team 6", "FSFT", "German G", "Christina G", "Cuong", "Aman", "Ford Sisters", "Charlie"].includes(discountCode.trim()) ? 10 : total;
    setTotalPrice(final);
  }, [numTiers, toppers, edibleAddOns, dietaryRestrictions, servings, discountCode, deliveryMethod]);

  const captureCakeImage = async () => {
    if (!cakeRef.current) return null;
  
    try {
      const dataUrl = await toPng(cakeRef.current); // base64 string
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], `custom_cake_${Date.now()}.png`, { type: "image/png" });
  
      return { file, dataUrl };
    } catch (err) {
      console.error("Failed to capture cake image", err);
      return null;
    }
  };
  
  


  const handleCheckout = async () => {
    // Validate the required fields
    if (!contactFieldsAreValid) {
        alert('Please fill in all required fields before submitting!');
        return;
    }
    setIsLoading(true);
    try {
        // First, submit cake order so the email goes out
        //await handleSubmitCakeOrder();
        //store local stuff

        const captured = await captureCakeImage();
        let cakeImageFilename = "";
        let cakeImageBase64 = "";
        
        if (captured) {
          const { file, dataUrl } = captured;
          cakeImageBase64 = dataUrl;
        
          const ext = file.type.split("/")[1]; // Should be "png"
          const presignRes = await axios.get(
            `https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=cake_render&ext=${ext}`
          );
        
          cakeImageFilename = presignRes.data.filename;
          const uploadUrl = presignRes.data.uploadUrl;
          await axios.put(uploadUrl, file);
        }
        
       

        localStorage.setItem("cakeOrderInfo", JSON.stringify({
          guestEmail: email,
          guestPhone: phone,
          guestName: name,
          preferredContactMethod: contactMethod,
          deliveryMethod,
          address,
          dateNeeded,
          urlPathName: "generic-quote-request",
          numTiers: parseInt(numTiers),
          tierShape: "round",
          cakeFlavors: Object.fromEntries(
            tierFlavors.map((tier, idx) => [idx + 1, tier.cake || "Not selected"])
          ),
          icingFlavors: Object.fromEntries(
            tierFlavors.map((tier, idx) => [idx + 1, tier.icing || "Not selected"])
          ),
          dietaryRestrictions,
          designNotes: otherFeedback || "N/A",
          toppers,
          edibleAddOns,
          customName,
          tierFlavors,
          servings: numTiers === "1" ? 20 : 36,

          showCongratsInput,
          numberofTiersPrice,
          toppersPrice,
          edibleAddonsPrice,
          customMessagePrice,
          dietaryRestrictionsPrice,
          totalPrice,
          cakeImageFilename,
          cakeImageBase64,
          deliveryFee,
        }));        


        // Make a POST request to your Lambda function to create a Stripe Checkout session
        const response = await axios.post(
        'https://uzm3pwdaakgbxor7kakaifw2fi0pdegz.lambda-url.us-east-1.on.aws/',
        {
            items: [
            {
                price_data: {
                currency: 'usd',
                product_data: {
                    name: `${numTiers}-tier Graduation Cake`
                },
                unit_amount: totalPrice * 100
                },
                quantity: 1
            }
            ],
          successUrl: isLocalhost
          ? "http://localhost:3000/payment-success"
          : "https://cakery.co/payment-success",
          cancelUrl: isLocalhost
            ? "http://localhost:3000/cancelled"
            : "https://cakery.co/cancelled",
            guestEmail: email,
            guestPhone: phone,
        }
        );

        const { sessionId } = response.data;

        // Redirect to Stripe checkout page
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({ sessionId });

        if (error) {
        console.error('Error during checkout:', error);
        }
    } catch (error) {
        console.error('Error creating checkout session:', error);
        alert('An error occurred while processing your payment.');
    }
    finally {
      setIsLoading(false); // ✅ Hide loading spinner if Stripe fails
    }
    };

  const topperOptions = [
    { value: "owl", label: "Edible Fondant Owl ($75)" },
    { value: "happy graduation", label: "Happy Graduation Topper ($15)" },
    { value: "balloons", label: "Balloons ($10)" },
  ];

  const edibleOptions = [
    { value: "gold foil", label: "Gold Foil ($45)" },
    { value: "congratulations", label: "Congratulations <Name> ($20)" },
    { value: "ricelogo", label: "Rice Logo ($25)" },
  ];

  const dietaryOptions = [
    { value: "gluten-free", label: "Gluten-Free (30 cents / serving)" },
    { value: "nut-free", label: "Nut-Free" },
    { value: "dairy-free", label: "Dairy-Free" },
    { value: "vegan", label: "Vegan" },
  ];

  const cakeFlavorOptions = [
    { value: "vanilla", label: "Vanilla" },
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "lemon", label: "Lemon" },
  ];
  
  const icingFlavorOptions = [
    { value: "vanilla buttercream", label: "Vanilla Buttercream" },
    { value: "chocolate buttercream", label: "Chocolate Buttercream" },
  ];  

  const formatPrice = (price) => {
    return Number(price) % 1 === 0 ? `$${Number(price)}` : `$${Number(price).toFixed(2)}`;
  };
  

  const renderCheckboxGroup = (options, selectedValues, setSelectedValues) => (
    <div className="d-flex flex-column align-items-start w-100">
      {options.map((opt) => (
        <Form.Check
          key={opt.value}
          type="checkbox"
          id={opt.value}
          label={opt.label}
          checked={selectedValues.includes(opt.value)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedValues([...selectedValues, opt.value]);
            } else {
              setSelectedValues(selectedValues.filter((v) => v !== opt.value));
            }
          }}
          className="mb-2"
          style={{ accentColor: "#ff5fa2" }}
        />
      ))}
    </div>
  );



  const handleSubmitCakeOrder = async () => {
    try {





      const payload = {
        numberofTiersPrice,
        toppersPrice,
        edibleAddonsPrice,
        customMessagePrice,
        dietaryRestrictionsPrice,
        totalPrice,

        guestEmail: email,
        guestPhone: phone,
        urlPathName: "generic-quote-request",
        numTiers: parseInt(numTiers),
        tierShape: "round",
        cakeFlavors: Object.fromEntries(
          tierFlavors.map((tier, idx) => [idx + 1, tier.cake || "Not selected"])
        ),
        icingFlavors: Object.fromEntries(
          tierFlavors.map((tier, idx) => [idx + 1, tier.icing || "Not selected"])
        ),
        decorations: [dateNeeded || "No date provided"],
        dietaryRestrictions: dietaryRestrictions,
        designNotes: otherFeedback || "N/A",
        
        // Add these fields for the price table in the email
        toppers: toppers,
        edibleAddOns: edibleAddOns,
        customName: customName,
        tierFlavors: tierFlavors,
        servings: numTiers === "1" ? 20 : 36,
        basePrice: numTiers === "1" ? 85 : 185,
        showCongratsInput: showCongratsInput,
        deliveryMethod,
        deliveryFee
      };
  
      console.log("Submitting Cake Order:", payload);
  
      const response = await axios.post(
        "https://kld931ajj1.execute-api.us-east-1.amazonaws.com/v1/custom-grad-cake",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
  
      alert("Cake order submitted! 🎉 We'll be in touch soon.");
    } catch (error) {
      console.error("Submission error:", error);
      alert("There was an error submitting your order.");
    }
  };

  const sections = [
    {
      label: "# Tiers",
      content: (
        <Form.Select
          value={numTiers}
          onChange={(e) => {
            const val = e.target.value;
            setNumTiers(val);
            setTierFlavors(
              val === "1"
                ? [{ cake: "vanilla", icing: "vanilla buttercream" }]
                : [
                    { cake: "vanilla", icing: "vanilla buttercream" },
                    { cake: "vanilla", icing: "vanilla buttercream" }
                  ]
            );            
          }}
        >
          <option value="1">1 Tier</option>
          <option value="2">2 Tiers</option>
        </Form.Select>
      ),
    },
    {
      label: "Topper(s)",
      content: renderCheckboxGroup(topperOptions, toppers, setToppers),
    },
    {
      label: "Edible Add-Ons",
      content: (
        <>
          {renderCheckboxGroup(edibleOptions, edibleAddOns, setEdibleAddOns)}
          {showCongratsInput && (
            <input
              type="text"
              className="form-control mt-2"
              placeholder="Enter name for congratulations message"
              value={customName}
              onChange={(e) => setCustomName(e.target.value)}
            />
          )}
        </>
      ),
    },
    {
      label: "Dietary Restrictions",
      content: renderCheckboxGroup(dietaryOptions, dietaryRestrictions, setDietaryRestrictions),
    },
    {
      label: "Flavors",
      content: (
        <div>
          {tierFlavors.map((tier, idx) => (
            <div key={idx} className="mb-3">
              {numTiers === "2" && <h6>Tier {idx + 1}</h6>}
              <Form.Label>Cake Flavor</Form.Label>
              <Form.Select
                className={`w-100 ${!tier.cake && reviewMode ? "is-invalid" : ""}`}
                value={tier.cake}
                onChange={(e) => {
                    const updated = [...tierFlavors];
                    updated[idx].cake = e.target.value;
                    setTierFlavors(updated);
                }}
                >
                {cakeFlavorOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
                </Form.Select>


              <Form.Label className="mt-2">Icing Flavor</Form.Label>
              <Form.Select
                 className={`w-100 mt-2 ${!tier.icing && reviewMode ? "is-invalid" : ""}`}
                value={tier.icing}
                onChange={(e) => {
                    const updated = [...tierFlavors];
                    updated[idx].icing = e.target.value;
                    setTierFlavors(updated);
                }}
                >
               
                {icingFlavorOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
                </Form.Select>


            </div>
          ))}
        
        </div>
      ),
    },
    {
      label: "Any Other Feedback",
      content: (
        <Form.Control
          as="textarea"
          rows={3}
          value={otherFeedback}
          onChange={(e) => setOtherFeedback(e.target.value)}
          placeholder="Let us know any additional info or feedback!"
        />
      ),
    },
    {
      label: "Review & Submit",
      content: reviewMode ? (
        <>
         <table className="table table-sm mt-3" style={{ fontSize: "0.9rem" }}>
            <thead>
                <tr>
                <th>Item</th>
                <th>Details</th>
                <th>Price</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td><strong>Number of Tiers</strong></td>
                <td>{numTiers}</td>
                <td>{formatPrice(numberofTiersPrice)}</td>
                </tr>
                <tr>
                <td><strong>Toppers</strong></td>
                <td>{toppers.length > 0 ? toppers.join(", ") : "None"}</td>
                <td>{formatPrice(toppersPrice)}</td>
                </tr>
                <tr>
                <td><strong>Edible Add-Ons</strong></td>
                <td>{edibleAddOns.length > 0 ? edibleAddOns.join(", ") : "None"}</td>
               
                <td>{formatPrice(edibleAddonsPrice)}</td>
                </tr>
                {showCongratsInput && (
                <>
                    <tr>
                    <td><strong>Custom Message</strong></td>
                    <td>Congratulations {customName}</td>
                    <td></td>
                    </tr>
                </>
                )}
                <tr>
                <td><strong>Dietary Restrictions</strong></td>
                <td>{dietaryRestrictions.length > 0 ? dietaryRestrictions.join(", ") : "None"}</td>
                <td>{formatPrice(dietaryRestrictionsPrice)}</td>
                </tr>
                <tr>
                <td><strong>Flavors</strong></td>
                <td colSpan="2">
                    {tierFlavors.map((tier, idx) => (
                    <div key={idx}>
                        {numTiers === "2" && <strong>Tier {idx + 1}: </strong>}
                        {tier.cake || tier.icing ? `${tier.cake} cake with ${tier.icing} icing` : "Not selected"}
                    </div>
                    ))}
                </td>
                </tr>
                {otherFeedback && (
                <tr>
                  <th>Other Feedback</th>
                  <td colSpan="2">{otherFeedback}</td>
                </tr>
              )}
              <tr>
                <td><strong>Delivery Method</strong></td>
                <td>{deliveryMethod === "delivery" ? "Delivery" : "Pickup"}</td>
                <td>{formatPrice(deliveryFee)}</td>
              </tr>

                <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{formatPrice(totalPrice)}</strong></td>
                </tr>
               
            </tbody>
            </table>



          <h5 className="text-start mt-3">Contact Info</h5>
          <Form.Group className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={reviewMode && !name ? "is-invalid" : ""}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={reviewMode && !email ? "is-invalid" : ""}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Phone #</Form.Label>
            <Form.Control
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className={reviewMode && !phone ? "is-invalid" : ""}
            />

          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Preferred Contact Method</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Email"
                checked={contactMethod === "email"}
                onChange={() => setContactMethod("email")}
              />
              <Form.Check
                inline
                type="radio"
                label="Phone"
                checked={contactMethod === "phone"}
                onChange={() => setContactMethod("phone")}
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Delivery Method</Form.Label>
            <div>
                <Form.Check
                inline
                type="radio"
                label="Pickup"
                checked={deliveryMethod === "pickup"}
                onChange={() => setDeliveryMethod("pickup")}
                />
                <Form.Check
                inline
                type="radio"
                label="Delivery"
                checked={deliveryMethod === "delivery"}
                onChange={() => setDeliveryMethod("delivery")}
                />
            </div>
            {deliveryMethod === "delivery" ? (
               <>
                <Form.Control
                type="text"
                placeholder="Enter delivery address"
                value={address}
                className="mt-2"
                onChange={(e) => setAddress(e.target.value)}
                />
                 <div className="mt-2 text-danger fw-semibold">Delivery will cost $75.</div>
              </>
                
            ) : (
                <Form.Text muted>
                Pickup will likely be in the Heights in Houston, TX. We will reach out to you when details are more finalized for the cake.
                </Form.Text>
            )}
            </Form.Group>
            


          {delivery ? (
            <Form.Group className="mb-2">
              <Form.Label>Delivery Address</Form.Label>
              <Form.Control
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Form.Group>
          ) : (
           <br></br>
          )}
          <Form.Group className="mb-2">
            <Form.Label>Date Needed</Form.Label>
            <Form.Control
            type="date"
            value={dateNeeded}
            onChange={(e) => setDateNeeded(e.target.value)}
            className={reviewMode && !dateNeeded ? "is-invalid" : ""}
            />
            </Form.Group>
          <Form.Group className="mb-4">

          <Form.Group className="mb-3">
          <Form.Label>Discount Code</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter discount code"
            value={discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
          />
          {discountCode.trim() === "Team 6" && (
            <Form.Text className="text-success">💖 Thanks for being the best team ever. Your total is now $10.</Form.Text>
          )}
          {discountCode.trim() === "FSFT" && (
            <Form.Text className="text-success">🎉 Thank you Frogs, Snails, and Fairy Tales! Your total is now $10.</Form.Text>
          )}
          {discountCode.trim() === "Cuong" && (
            <Form.Text className="text-success">💖  Thank you Cuong for believing in Cakery. Your total is now $10.</Form.Text>
          )}
           {discountCode.trim() === "Christina G" && (
            <Form.Text className="text-success">💖  Thank you Christina for everything you've done for Cakery. Your total is now $10.</Form.Text>
          )}
           {discountCode.trim() === "German G" && (
            <Form.Text className="text-success">💖  Thank you German for everything you've done for Cakery. Your total is now $10.</Form.Text>
          )}
           {discountCode.trim() === "Aman" && (
            <Form.Text className="text-success"> Thank you Aman for everything you've done for Cakery. Your total is now $10.</Form.Text>
          )}
           {discountCode.trim() === "Ford Sisters" && (
            <Form.Text className="text-success"> Thank you Ford Sisters for everything you've done for Cakery. Your total is now $10.</Form.Text>
          )}
           {discountCode.trim() === "Charlie" && (
            <Form.Text className="text-success"> Thank you Charlie for everything you've done for Cakery. Your total is now $10.</Form.Text>
          )}
        </Form.Group>



          <div
          className="text-muted"
          style={{
            fontSize: "0.85rem",
            lineHeight: "1.4",
            maxHeight: "120px",
            overflowY: "auto",
            paddingRight: "8px"
          }}
        >
            All cakes are custom and may vary from the rendered design. Bakers retain creative discretion and may make reasonable design adjustments. 
          Specific design requests should be clearly communicated at the time of order.

          <br /><br />
          Cakery acts as an intermediary between customers and independent local bakers. 
          Once an order is submitted, Cakery forwards the order to the selected bakery and confirms receipt. 
          From that point on, the bakery is responsible for working directly with the customer to fulfill the cake order as described.

          <br /><br />
          For any questions or concerns about your order, please contact our team at <a href="mailto:gocakery@gmail.com">gocakery@gmail.com</a>.
        </div>

            <br></br>
            <Form.Label className="mb-2" style={{ fontSize: "0.95rem", fontWeight: "500" }}>
            <Form.Check
                type="checkbox"
                inline
                id="agreeTerms"
                label="I agree to the terms"
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
                style={{ transform: "scale(1.2)", marginRight: "10px" }}
            />
            </Form.Label>

           
        </Form.Group>

        {submitDisabled && (
        <div className="text-danger mb-2">
            Please complete all required fields before submitting.
        </div>
        )}
       <Button
        disabled={submitDisabled}
        onClick={handleCheckout}
        style={{ backgroundColor: "#ff5fa2", borderColor: "#ff5fa2" }}
        >
        Order My Graduation Cake!
        </Button>



          <div className="mt-3">
            <Button variant="outline-secondary" onClick={() => setReviewMode(false)}>
              Back
            </Button>
          </div>
        </>
      ) : (
        <div className="d-grid">
          <Button onClick={() => setReviewMode(true)} style={{ backgroundColor: "#ff5fa2", borderColor: "#ff5fa2" }}>
            Review / Submit
          </Button>
        </div>
      )
    }
  ];


  const clearAll = () => {
    setToppers([]);
    setEdibleAddOns([]);
    setCustomName("");
    setDietaryRestrictions([]);
    setTierFlavors([{ cake: "", icing: "" }, ...(numTiers === "2" ? [{ cake: "", icing: "" }] : [])]);
    setOtherFeedback("");
  };


  

  return (
    <>
    {isLoading && (
      <div className="page-loading-overlay">
        <div className="spinner-border text-primary" role="status" />
      </div>
    )}
    
    <Container className="mt-4 pb-5">
      <Card className="p-4 shadow mx-auto" style={{ maxWidth: "900px" }}>
        <h2 className="text-center mb-4">Customize Your Graduation Cake</h2>
        <Row className="justify-content-center">
          <Col lg={8} className="d-flex flex-column align-items-center">
            <div
             ref={cakeRef}
              style={{
                position: "relative",
                width: "300px",
                height: "300px",
                border: "1px solid gray",
                marginBottom: "1rem",
              }}
            >
              <img
                src={`${window.location.origin}/grad-cake-builder/${numTiers}tier_cake.png`}
                alt="Base Cake"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 1 }}
              />
              {toppers.map((topper, idx) => (
                <img
                  key={topper}
                  src={`${window.location.origin}/grad-cake-builder/${numTiers}tier_${topper.replace(/ /g, "").toLowerCase()}.png`}
                  alt={topper}
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 10 + idx }}
                />
              ))}
              {edibleAddOns.map((item, idx) => (
                <img
                  key={item}
                  src={`${window.location.origin}/grad-cake-builder/${numTiers}tier_${item.replace(/ /g, "").toLowerCase()}.png`}
                  alt={item}
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 30 + idx }}
                />
              ))}
            </div>
            <div className="text-center">
              <h5>Total: ${totalPrice}</h5>
              <p>{numTiers === "1" ? 20 : 36} servings</p>
              <div className="text-center mb-2">
                <Button
                  variant="outline-secondary"
                  className="me-2"
                  onClick={() => setFormStep((s) => (s > 0 ? s - 1 : s))}
                >
                  <ChevronLeft />
                </Button>
                <span>{formStep + 1} / {sections.length}</span>
                <Button
                  variant="outline-secondary"
                  className="ms-2"
                  onClick={() => setFormStep((s) => (s + 1 < sections.length ? s + 1 : s))}
                >
                  <ChevronRight />
                </Button>
              </div>
              <div style={{ maxWidth: "100%" }}>
                <h6 className="text-center mb-2">{sections[formStep].label}</h6>
                {sections[formStep].content}
              </div>
              <Button variant="link" className="mt-3 text-danger" onClick={clearAll}>
                Clear All
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
    </Container>
    </>
  );
}